@if (viewHeader) {
  <app-header></app-header>
}

<div class="">
  <router-outlet />
</div>

@if (viewHeader) {
  <!--
  La tira de partners salió de adentro del pie y quedó sobre él: Kráneo la pidió
  "un poco más arriba en la página" porque a los partners les interesa notarse
  (ABC-391). Así el bloque de descarga de la app, que vive en el pie, queda
  debajo.
-->
  <app-partners-carousel></app-partners-carousel>
  <app-footer></app-footer>
}
